import {NotificationDTO} from '../../generated/api'

export const getGuildId = (notification: NotificationDTO) => {
    return notification?.parameters?.find((param) => param.label === 'Guild Id')?.value
}

